<template>
  <div  class="headerWrapper">

    <header  class="header">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <!-- <a  href="/" style="display: inline-block;height: 80px;float: left;padding-right: 36px">
          <img src="../assets/logo8652852.png" alt="element-logo" class="nav-logo">
        </a> -->
        <el-menu-item index="2">
          <router-link to='/' style="display: inline-block;height: 80px;color: black"><i class="el-icon-s-home" style="color: #f56c6c;vertical-align: unset!important;"></i>首页</router-link>
        </el-menu-item>
        <el-menu-item index="3">
          <router-link to='/orderList' style="display: inline-block;height: 80px;text-decoration: blink;color: black">历史订单</router-link>
        </el-menu-item>
        <el-menu-item index="4">
          <router-link to='/mailList' style="display: inline-block;height: 80px;text-decoration: blink;color: black">站内信({{mailCount}})</router-link>
        </el-menu-item>
        <div class='top-bar__right' style="display: inline-block;width: 68%">
          <div style="display: inline-block;padding-right: 26px;width: 62%">
            <!--<el-select
              ref="headerSearchSelect"
              v-model="search"
              :remote-method="querySearch"
              filterable
              default-first-option
              remote
              placeholder="Search"
              class="header-search-select"
              @change="change"
            >
              <el-option v-for="item in options" :key="item.path" :value="item" :label="item.title.join(' > ')" />
            </el-select>-->
            <el-input placeholder="搜索商品" v-model="searchStr" class="input-with-select"  @keyup.enter.native="openShopList">
              <el-button slot="append" icon="el-icon-search" @click="openShopList"></el-button>
            </el-input>
          </div>
          <div style="display: inline-block;padding-right: 36px">
            <el-button type="danger" icon="el-icon-shopping-cart-2" @click="openCart">购物车</el-button>
          </div>
          <!-- <el-button type="text" @click="login" v-if="user.uid">操作人员管理</el-button> -->
          <!-- <el-tooltip effect='dark'
                      content='用户头像'
                      placement='bottom'>
            <img class='top-bar__img'
                 :src="user.uid?user.avatar:userInfo.avatar">
          </el-tooltip> -->
          <el-button type="text" @click="login" v-if="!user.uid">登录</el-button>
          <el-dropdown style="width: 100px" v-else>
              <span class='el-dropdown-link'>
                {{user.nickname.length>4?user.nickname.substring(0,3)+'....':user.nickname}}
                <i class='el-icon-arrow-down el-icon--right'></i>
              </span>
            <el-dropdown-menu slot='dropdown'>
              <el-dropdown-item @click.native='logout'>退出系统</el-dropdown-item>
              <el-dropdown-item @click.native="toAddManager">修改密码</el-dropdown-item>
              <el-dropdown-item @click.native='openConMananer' v-if="user.isOfficeAdmin===1">管理操作员</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-menu>
<!--      <div  class="container">-->
<!--        &lt;!&ndash;<h1 ><a  href="/" class="router-link-active">-->
<!--        <img src="../assets/logo8652852.png" alt="element-logo" class="nav-logo">-->
<!--      </a></h1>-->
<!--        <ul>-->
<!--          <li >-->
<!--            <router-link to='/' style="color: black"><i class="el-icon-s-home" style="color: #f56c6c"></i>首页</router-link>-->
<!--          </li>-->
<!--          <li >-->
<!--            <router-link to='/history/orderList' style="text-decoration: blink;color: black">历史订单</router-link>-->
<!--          </li>-->
<!--          <li >-->
<!--            <router-link to='/mailList' style="text-decoration: blink;color: black">站内信<span>(10)</span></router-link>-->
<!--          </li>-->
<!--        </ul>&ndash;&gt;-->
<!--      </div>-->
    </header>
      <changePassWord @childFn="parentFiloatDissFn" v-if="isShowAdd" ></changePassWord>
    <div style="position: fixed;bottom: 0px;background-color: #ebeef5;width: 100%" v-if="cartNumber > 0">
      <el-button type="danger" style="float: right;margin-right: 200px;margin-top: 4px;"  @click="addCart">添加购物车</el-button>
    </div>
  </div>
<!--    <router-view :key="key"></router-view>-->
</template>
<script>
import top from './top/index'
import logo from '../assets/logo8652852.png'
import { mapActions, mapGetters } from 'vuex'
import store from '@/store'
import changePassWord from '@/components/changePassWord'
export default {
  name: 'layout',
  components: {top, changePassWord},
  props: {
    addCartShow: {
      type: Number,
      required: false
    },
    activeIndex: {
      type: String,
      required: false,
      default: '1'
    }
  },
  data () {
    return {
      isShowAdd:false,
      search: this.$store.getters.getSearchStr,
      options: [],
      totalPage: this.$store.getters.getMailCount,
      userInfo: {
        avatar: logo,
        username: ''
      }
    }
  },
  created () {
    console.log(this.$store.getters.getTokenKy + '9999999999')
    if (this.$store.getters.getTokenKy) {
      this.getUserInfo()
      this.getMailList()
    }
  },
  methods: {
     parentFiloatDissFn () {
      this.isShowAdd = false

    },
     toAddManager() {
      this.isShowAdd = true
    },
    getMailList () {
      var p = 1
      this.$axios({
        url: '/article/list/page',
        method: 'get',
        params: {
          page: p,
          readStatus: 0
        }
      }).then((response) => {
        this.totalPage = response.data.totalElements
        console.log(response)
        store.dispatch('setMailCount', response.data.totalElements)
      }).catch((error) => {
        console.log(error)
      })
    },
    getUserInfo () {
      this.$axios
        .get('/userinfo')
        .then(res => {
          // “001”代表登录成功，其他的均为失败
          console.log(res)
          if (res.data.status === 200) {
            // this.setUser(res.data.data)
            store.dispatch('setUser', res.data.data)
          } else {
          }
        })
        .catch(err => {
          return Promise.reject(err)
        })
    },
    addCart () {
      if (this.$store.getters.getCartList.length > 0) {
        this.$axios({
          url: '/cart/addList',
          method: 'post',
          data: this.$store.getters.getCartList
        }).then((response) => {
          console.log(response)
          if (response.data.status === 200) {
            store.dispatch('setCartList', [])
            store.dispatch('setCartNumber', 0)
            this.$router.push({ path: '/shoppingCart' })
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        this.$message({
          type: 'error',
          message: '请选择商品'
        })
      }
    },
    ...mapActions(['setUser', 'setShowLogin', 'setSearchStr']),
    login () {
      // 点击登录按钮, 通过更改vuex的showLogin值显示登录组件
      this.setShowLogin(true)
    },
    changePass () {

    },
    logout () {
      store.dispatch('LogOut').then(() => {})
    },
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    },
    openShopList () {
      console.log(!(this.$route.path === '/shopList'))
      store.dispatch('setSearchStr', this.searchStr)
      if (!(this.$route.path === '/shopList')) {
        this.$router.push({ path: '/shopList' })
      }
    },
    openCart () {
      this.$router.push({ path: '/shoppingCart' })
    },
    openConMananer () {
      this.$router.push({ path: '/operatorManager' })
    },
    change (val) {
      console.log('')
    },
    querySearch () {
      console.log('')
    }
  },
  computed: {
    ...mapGetters(['getUser', 'getNum']),
    key () {
      return this.$route.path
    },
    user () {
      console.log(this.$store.getters.getUser + '5555555')
      return this.$store.getters.getUser
    },
    cartNumber: {
      get () {
        return this.$store.getters.getCartNumber
      }
    },
    searchStr: {
      get () {
        return this.$store.getters.getSearchStr
      },
      set (val) {
        this.setSearchStr(val)
      }
    },
    mailCount: {
      get () {
        return this.$store.getters.getMailCount
      }
    }
  }
}
</script>

<style scoped>
  .el-menu-demo{
    width: 77%;
    margin: auto;
    background: border-box;
    padding-inline-start: 0;
    height: 80px;
  }
  .el-menu-item{
    line-height: 80px!important;
    height: 80px!important;
  }

  .el-menu-item:hover{
    background-color: rgba(245, 108, 108, 0.1) !important;
  }
  .headerWrapper {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 1500;
  }
  .header {
    /*height: 80px;*/
    background-color: #ebeef5;
    color: #fff;
    top: 0;
    left: 0;
    width: 100%;
    line-height: 80px;
    z-index: 100;
    position: relative;
    box-sizing: border-box;
    border-bottom: 1px solid #dcdfe6;
  }
  .container {
    height: 100%;
    width : 1250px;
    box-sizing: border-box;
    border-bottom: 1px solid #dcdfe6;
    margin: 0 auto;
  }
  .header h1 {
    margin: 0;
    float: left;
    font-size: 20px;
    font-weight: 400;
    width: 96px;
    height: 100%;
    margin-right: 21px;
  }
  h1 {
    display: block;
    font-size: 2em;
    margin-block-start: 0.67em;
    margin-block-end: 0.67em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
  }
  .header .nav {
    float: right;
    height: 100%;
    line-height: 80px;
    background: transparent;
    padding: 0;
    margin: 0;
  }
  ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 0em;
    margin-block-end: 0em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  .header .nav-item {
    margin: 0;
    float: left;
    list-style: none;
    position: relative;
    cursor: pointer;
  }
  li {
    display: list-item;
    text-align: -webkit-match-parent;
  }
  .header .nav-item a {
    text-decoration: none;
    color: #1989fa;
    opacity: .5;
    display: block;
    padding: 0 22px;
  }
  .header .nav-item a.active, .header .nav-item a:hover {
    opacity: 1;
  }
  h1.router-link-active{
    width: 70px;
    height: 70px;
    display: block;
    padding: 4px;
  }
  .nav-logo{
    /*width: 100%;*/
    height: 96%;
    padding-top: 3px;
  }
  .top-bar__img {
    margin: 0 8px 0 5px;
    padding: 2px;
    width: 50px;
    height: 50px;
    border-radius: 100%;
    box-sizing: border-box;
    border: 1px solid #eee;
    vertical-align: middle;
  }
  .top-bar__left {
    left: 0;
  }

  .top-bar__right {
    float: right;
  }
  .top-bar__right:focus {
    outline: -webkit-focus-ring-color auto 0px;
  }

  .top-bar__title {
    padding-left: 40px;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: inherit;
    font-weight: 400;
  }
  .router-link-active {
    text-decoration: blink;
    color: black;
  }
  .el-dropdown-menu{
    padding-inline-start: 0px;
  }
  .el-dropdown-menu a{
    text-decoration: blink;
    color: black;
  }
  .el-dropdown-menu a:hover{
    background-color: #ecf5ff;
    color: #66b1ff;
  }
  .header .nav-item a.active:after {
    content: "";
    display: inline-block;
    position: absolute;
    bottom: 0;
    left: calc(50% - 15px);
    width: 30px;
    height: 2px;
    background: #409eff;
  }
</style>
<style type="text/css">
  .el-badge__content {
    top: 20px;
  }
  .input-with-select{
    width: 100%!important;
  }
  .el-input-group__append, .el-input-group__prepend {
    background-color: #f56c6c;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/layout/index.vue